<div class="VehicleCard" [class.VehicleCard--error]="hasAnyTelemetryIssue()">
    <!-- Left: Vehicle Info -->
    @if (showVehicleInfo) {
        <div class="VehicleCard__Left">
            <div class="VehicleCard__PlateSection">
                <div class="VehicleCard__Plate">{{ item.unit.plate }}</div>
                <mat-chip color="primary" selected style="margin: 0 auto; display: block; font-size: 0.8rem; font-weight: 600; text-transform: uppercase;">{{ item.unit.state || 'N/A' }}</mat-chip>
            </div>
            <div class="VehicleCard__Details">
                <span>{{ item.unit.brand }} - {{ item.unit.model }}</span>
                <span class="VehicleCard__VIN">{{ item.unit.vin }}</span>
            </div>
        </div>
    }

    <!-- Center: Telemetry Status -->
    <div class="VehicleCard__Center">
        <div class="VehicleCard__TelemetryItem" [class.VehicleCard__TelemetryItem--warning]="isOlderThan48Hours(item.telemetry.odometer.updatedAt)">
            <mat-icon>speed</mat-icon>
            <div class="VehicleCard__TelemetryContent">
                <span class="VehicleCard__TelemetryValue">{{ item.telemetry.odometer.value | number:'1.0-0' }} km</span>
                <span class="VehicleCard__TelemetryDate">
                    {{ formatDate(item.telemetry.odometer.updatedAt) }}
                    @if (!item.telemetry.odometer.updatedAt || isOlderThan48Hours(item.telemetry.odometer.updatedAt)) {
                        <mat-icon class="VehicleCard__TelemetryWarningIcon">warning</mat-icon>
                    }
                </span>
            </div>
        </div>

        <div class="VehicleCard__TelemetryItem" [class.VehicleCard__TelemetryItem--warning]="isOlderThan48Hours(item.telemetry.gps.updatedAt)">
            <mat-icon>location_on</mat-icon>
            <div class="VehicleCard__TelemetryContent">
                <span class="VehicleCard__TelemetryLabel">GPS</span>
                <span class="VehicleCard__TelemetryDate">
                    @if (item.telemetry.gps.updatedAt) {
                        {{ formatDate(item.telemetry.gps.updatedAt) }}
                    }
                    @if (!item.telemetry.gps.updatedAt || isOlderThan48Hours(item.telemetry.gps.updatedAt)) {
                        <mat-icon class="VehicleCard__TelemetryWarningIcon">warning</mat-icon>
                    }
                </span>
            </div>
        </div>

        <div class="VehicleCard__TelemetryItem" [class.VehicleCard__TelemetryItem--warning]="isOlderThan48Hours(item.telemetry.can.updatedAt)">
            <mat-icon>settings</mat-icon>
            <div class="VehicleCard__TelemetryContent">
                <span class="VehicleCard__TelemetryLabel">CAN</span>
                <span class="VehicleCard__TelemetryDate">
                    @if (item.telemetry.can.updatedAt) {
                        {{ formatDate(item.telemetry.can.updatedAt) }}
                    }
                    @if (!item.telemetry.can.updatedAt || isOlderThan48Hours(item.telemetry.can.updatedAt)) {
                        <mat-icon class="VehicleCard__TelemetryWarningIcon">warning</mat-icon>
                    }
                </span>
            </div>
        </div>
    </div>

    <!-- Right: Provider -->
    <div class="VehicleCard__Right">
        <div class="VehicleCard__Provider">{{ item.telemetry.provider }}</div>
        <div class="VehicleCard__IDX">IDX: {{ item.telemetry.idx }}</div>
    </div>
</div>
